import { render, staticRenderFns } from "./WModal.vue?vue&type=template&id=09fc9492&scoped=true&lang=pug&"
import script from "./WModal.vue?vue&type=script&lang=js&"
export * from "./WModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fc9492",
  null
  
)

export default component.exports